export default __webpack_public_path__ + "static/media/news102.0234fee5.jpg";